import { gallery } from './api';

/** Paper sizes in the order they are offered. */
export const FORMATS = ['A4', 'LETTER', 'A3', 'TABLOID', 'LEGAL', 'CUSTOM'];

/** The sizes a pattern has a PDF for. Patterns listed without that information offer them all. */
export function availableFormats(formats) {
  return Array.isArray(formats) ? FORMATS.filter((format) => formats.includes(format)) : FORMATS;
}

/**
 * Records the download and saves the PDF. The API only answers with the PDF's address under /files;
 * the browser downloads it from there. Throws an ApiError (401 when signed out, 404 when the
 * pattern has no PDF in that size).
 */
export async function downloadPdf(patternId, format) {
  const { url, fileName } = await gallery.download(patternId, format);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.rel = 'noopener';
  document.body.append(link);
  link.click();
  link.remove();
}
